import { Box, Grid, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Column } from 'further-ui/components/Layout';
import { numberToDisplayString } from 'further-ui/utils';

const ScrollContainer = styled(Box)({
  overflowX: 'auto',
});

const ScrollContent = styled(Box)({
  minWidth: 650,
});

type CurrentValuationRowProps = {
  currentValuation: {
    currentHoldValue: string;
    currentHoldValueLcy?: string;
    averageUnitPriceTcy: string;
    latestRevaluationDate: string;
    currentNumberOfUnits: number;
  };
  newValuation: {
    holdValue: string;
    holdValueLcy?: string;
    averageUnitPriceTcy: string;
    numberOfUnits: number;
    revaluationDate: string;
  };
  isNonLcy?: boolean;
  holdValueTcyLabel?: string;
  holdValueLcyLabel?: string;
};

const CurrentValuationRow: React.FC<CurrentValuationRowProps> = ({
  currentValuation: {
    currentHoldValue,
    currentHoldValueLcy,
    averageUnitPriceTcy,
    latestRevaluationDate,
    currentNumberOfUnits,
  },
  newValuation,
  isNonLcy,
  holdValueTcyLabel = 'Total hold value',
  holdValueLcyLabel = 'Total hold value (LCY)',
}) => {
  return (
    <ScrollContainer>
      <ScrollContent>
        <Column spacing="sm">
          <Grid container spacing={2}>
            <Grid size="grow"></Grid>
            <Grid size="grow">
              <Typography variant="h6">{holdValueTcyLabel}</Typography>
            </Grid>
            {isNonLcy && (
              <Grid size="grow">
                <Typography variant="h6">{holdValueLcyLabel}</Typography>
              </Grid>
            )}
            <Grid size="grow">
              <Typography variant="h6">Average unit price</Typography>
            </Grid>
            <Grid size="grow">
              <Typography variant="h6">Units held</Typography>
            </Grid>
            <Grid size="grow">
              <Typography variant="h6">Revaluation date</Typography>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid size="grow">
              <Typography variant="h6" color="grey.600">
                Current valuation
              </Typography>
            </Grid>
            <Grid size="grow">
              <Typography variant="body2" color="grey.900">
                {currentHoldValue}
              </Typography>
            </Grid>
            {isNonLcy && (
              <Grid size="grow">
                <Typography variant="body2" color="grey.900">
                  {currentHoldValueLcy ?? '-'}
                </Typography>
              </Grid>
            )}
            <Grid size="grow">
              <Typography variant="body2" color="grey.900">
                {averageUnitPriceTcy}
              </Typography>
            </Grid>
            <Grid size="grow">
              <Typography variant="body2" color="grey.900">
                {numberToDisplayString(currentNumberOfUnits)}
              </Typography>
            </Grid>
            <Grid size="grow">
              <Typography variant="body2" color="grey.900">
                {latestRevaluationDate}
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid size="grow">
              <Typography variant="h6" color="grey.600">
                New valuation
              </Typography>
            </Grid>
            <Grid size="grow">
              <Typography variant="body2" color="grey.900">
                {newValuation.holdValue}
              </Typography>
            </Grid>
            {isNonLcy && (
              <Grid size="grow">
                <Typography variant="body2" color="grey.900">
                  {newValuation.holdValueLcy ?? '-'}
                </Typography>
              </Grid>
            )}
            <Grid size="grow">
              <Typography variant="body2" color="grey.900">
                {newValuation.averageUnitPriceTcy}
              </Typography>
            </Grid>
            <Grid size="grow">
              <Typography variant="body2" color="grey.900">
                {numberToDisplayString(newValuation.numberOfUnits)}
              </Typography>
            </Grid>
            <Grid size="grow">
              <Typography variant="body2" color="grey.900">
                {newValuation.revaluationDate}
              </Typography>
            </Grid>
          </Grid>
        </Column>
      </ScrollContent>
    </ScrollContainer>
  );
};

export default CurrentValuationRow;
